import React, { ReactElement, JSXElementConstructor } from "react";
import { Form, Typography, Col } from "antd";
import { FormInstance } from "antd/es/form";
import Header from "../Header/Header";
import "./StyledForm.css";
import ErrorTile from "../ErrorTile/ErrorTile";

const { Title } = Typography;

interface PageProps {
  formInstance: FormInstance;
  pageTitle: string;
  description?: string;
  formName: string;
  FormItems: () => ReactElement<any, string | JSXElementConstructor<any>>;
  onFinish: (values: any) => void;
  formSubmitError: string | null;
}

const StyledForm: React.FC<PageProps> = ({
  formInstance,
  pageTitle,
  description,
  formName,
  FormItems,
  onFinish,
  formSubmitError,
}) => (
  <div>
    <Header />
    <Col span={24}>
      <Title style={{ fontSize: "2rem", lineHeight: "2.5rem" }} level={1}>
        {pageTitle}
      </Title>
    </Col>
    <Col span={24}>
      <p className="page-description">{description}</p>
    </Col>
    <Col span={24}>
      {formSubmitError && <ErrorTile errorMessage={formSubmitError} />}
    </Col>
    <Col span={24}>
      <Form
        form={formInstance}
        name={formName}
        onFinish={onFinish}
        layout="vertical"
      >
        <FormItems />
      </Form>
      <a href="https://support.treez.io/hc/en-us/">Support Center</a>
    </Col>
  </div>
);

StyledForm.defaultProps = {
  description: "",
};

export default StyledForm;
